var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3139.1 353.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3{stroke-width:8px;}.cls-1,.cls-4{fill:#7da2fe;}.cls-1,.cls-3{stroke:#5d8bfe;}.cls-2{stroke:#386aff;}.cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-5{font-size:307.12px;}.cls-5,.cls-6{fill:#386aff;font-family:Georgia, Georgia;}.cls-7{fill:#5d8bfe;}.cls-6{font-size:307.12px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "929.04 133.81 914.86 169.67 943.21 169.67 929.04 133.81"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M929.04,202.85c-10.19,0-18.17-5.79-18.17-13.18,0-2.21,1.79-4,4-4h28.35c2.21,0,4,1.79,4,4,0,7.39-7.98,13.18-18.17,13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M943.21,189.67c0,5.04-6.4,9.18-14.17,9.18s-14.17-4.14-14.17-9.18h28.35m0-8h-28.35c-4.42,0-8,3.58-8,8,0,9.63,9.74,17.18,22.17,17.18s22.17-7.55,22.17-17.18c0-4.42-3.58-8-8-8h0Zm0,16h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "850.07 133.81 835.89 169.67 864.24 169.67 850.07 133.81"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M850.07,202.85c-10.19,0-18.17-5.79-18.17-13.18,0-2.21,1.79-4,4-4h28.35c2.21,0,4,1.79,4,4,0,7.39-7.98,13.18-18.17,13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M864.24,189.67c0,5.04-6.4,9.18-14.17,9.18s-14.17-4.14-14.17-9.18h28.35m0-8h-28.35c-4.42,0-8,3.58-8,8,0,9.63,9.74,17.18,22.17,17.18s22.17-7.55,22.17-17.18c0-4.42-3.58-8-8-8h0Zm0,16h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M875.24,86.43v-14.37c0-10.5,8.51-19.01,19.01-19.01h12.69c4.55,0,8.87,1.99,11.83,5.45l4.92,5.76s-19.12-1.93-19.12,22.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 937.82,
    y1: 53.17,
    x2: 1076.84,
    y2: 53.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M904.55,86.66c0,18.37,15.02,33.49,33.28,33.49s33.28-15.12,33.28-33.49-15.02-33.49-33.28-33.49"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M904.55,86.66c0,18.37,15.02,33.49,33.28,33.49s33.28-15.12,33.28-33.49-15.02-33.49-33.28-33.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1076.84,
    y1: 53.17,
    x2: 965.41,
    y2: 53.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1056.98,
    y1: 68.76,
    x2: 975.12,
    y2: 64.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1037.12,
    y1: 84.36,
    x2: 980.12,
    y2: 77.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1017.26,
    y1: 99.95,
    x2: 980.81,
    y2: 91.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 997.4,
    y1: 115.54,
    x2: 976.1,
    y2: 106.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 977.54,
    y1: 131.13,
    x2: 964.27,
    y2: 121.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 957.68,
    y1: 146.72,
    x2: 947.92,
    y2: 128.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M937.82,120.15c18.26,0,33.28-15.12,33.28-33.49s-15.02-33.49-33.28-33.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M916.64,259.96h-54.18c0-4.49,3.64-8.12,8.12-8.12h37.94c2.24,0,4.27,.91,5.74,2.38,1.47,1.47,2.38,3.51,2.38,5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M909.23,251.83h-39.36c0-4.49,2.64-8.12,5.9-8.12h27.56c1.63,0,3.1,.91,4.17,2.38,1.07,1.47,1.73,3.51,1.73,5.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 889.55,
    cy: 118.56,
    r: 8.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 889.55,
    cy: 132,
    r: 5.22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 841.96,
    y1: 53.17,
    x2: 702.95,
    y2: 53.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M875.24,86.66c0,18.37-15.02,33.49-33.28,33.49s-33.28-15.12-33.28-33.49,15.02-33.49,33.28-33.49"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M875.24,86.66c0,18.37-15.02,33.49-33.28,33.49s-33.28-15.12-33.28-33.49,15.02-33.49,33.28-33.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 702.95,
    y1: 53.17,
    x2: 814.38,
    y2: 53.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 722.81,
    y1: 68.76,
    x2: 804.67,
    y2: 64.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 742.67,
    y1: 84.36,
    x2: 799.67,
    y2: 77.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 762.53,
    y1: 99.95,
    x2: 798.98,
    y2: 91.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 782.39,
    y1: 115.54,
    x2: 803.69,
    y2: 106.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 802.25,
    y1: 131.13,
    x2: 815.52,
    y2: 121.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 822.11,
    y1: 146.72,
    x2: 831.87,
    y2: 128.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M841.96,120.15c-18.26,0-33.28-15.12-33.28-33.49s15.02-33.49,33.28-33.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 885.64,
    y: 118.56,
    width: 7.81,
    height: 135.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 889.55,
    cy: 118.56,
    r: 10.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 889.55,
    cy: 135.11,
    r: 6.43
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(1076.84 259.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Attorney Leads")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(0 259.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "lawyerpayperlead")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.cc204020cdf0ab40e069e7bcdb267ca0.svg";
export { ForwardRef as ReactComponent };